import { render, staticRenderFns } from "./DashConfig.vue?vue&type=template&id=145fecdf&scoped=true&"
import script from "./DashConfig.vue?vue&type=script&lang=js&"
export * from "./DashConfig.vue?vue&type=script&lang=js&"
import style0 from "./DashConfig.vue?vue&type=style&index=0&id=145fecdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145fecdf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VFlex,VIcon,VLayout,VProgressLinear,VSkeletonLoader})
